"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderAutocompleteControl = renderAutocompleteControl;
var _solidLogic = require("solid-logic");
var _solidUi = require("solid-ui");
var _autocompletePicker = require("./autocompletePicker");
var _publicData = require("./publicData");
// The Control with decorations

// dbpediaParameters

const WEBID_NOUN = 'Solid ID';
const kb = _solidLogic.store;

// const AUTOCOMPLETE_THRESHOLD = 4 // don't check until this many characters typed
// const AUTOCOMPLETE_ROWS = 12 // 20?

const GREEN_PLUS = _solidUi.icons.iconBase + 'noun_34653_green.svg';
const SEARCH_ICON = _solidUi.icons.iconBase + 'noun_Search_875351.svg';
async function renderAutocompleteControl(dom, person, options, addOneIdAndRefresh) {
  async function autoCompleteDone(object, _name) {
    const webid = object.uri;
    removeDecorated();
    return addOneIdAndRefresh(person, webid);
  }
  async function greenButtonHandler(_event) {
    const webid = await _solidUi.widgets.askName(dom, _solidLogic.store, creationArea, _solidUi.ns.vcard('url'), null, WEBID_NOUN);
    if (!webid) {
      return; // cancelled by user
    }
    return addOneIdAndRefresh(person, webid);
  }
  function removeDecorated() {
    if (decoratedAutocomplete) {
      creationArea.removeChild(decoratedAutocomplete);
      decoratedAutocomplete = null;
    }
  }
  async function searchButtonHandler(_event) {
    if (decoratedAutocomplete) {
      creationArea.removeChild(decoratedAutocomplete);
      decoratedAutocomplete = null;
    } else {
      decoratedAutocomplete = dom.createElement('div');
      decoratedAutocomplete.setAttribute('style', 'display: flex; flex-flow: wrap;');
      decoratedAutocomplete.appendChild(await (0, _autocompletePicker.renderAutoComplete)(dom, acOptions, autoCompleteDone));
      decoratedAutocomplete.appendChild(acceptButton);
      decoratedAutocomplete.appendChild(cancelButton);
      creationArea.appendChild(decoratedAutocomplete);
    }
  }
  async function droppedURIHandler(uris) {
    for (const webid of uris) {
      // normally one but can be more than one
      await addOneIdAndRefresh(person, webid);
    }
  }
  const queryParams = options.queryParameters || _publicData.wikidataParameters;
  const acceptButton = _solidUi.widgets.continueButton(dom);
  const cancelButton = _solidUi.widgets.cancelButton(dom, removeDecorated);
  const klass = options.class;
  const acOptions = {
    queryParams,
    class: klass,
    acceptButton,
    cancelButton
  };
  var decoratedAutocomplete = null;
  // const { dom } = dataBrowserContext
  options = options || {};
  options.editable = kb.updater.editable(person.doc().uri, kb);
  const creationArea = dom.createElement('div');
  creationArea.setAttribute('style', 'display: flex; flex-flow: wrap;');
  if (options.editable) {
    // creationArea.appendChild(await renderAutoComplete(dom, options, autoCompleteDone)) wait for searchButton
    creationArea.style.width = '100%';
    const plus = creationArea.appendChild(_solidUi.widgets.button(dom, GREEN_PLUS, options.idNoun, greenButtonHandler));
    _solidUi.widgets.makeDropTarget(plus, droppedURIHandler, null);
    if (options.dbLookup) {
      creationArea.appendChild(_solidUi.widgets.button(dom, SEARCH_ICON, options.idNoun, searchButtonHandler));
    }
  }
  return creationArea;
} // renderAutocompleteControl

// ends
//# sourceMappingURL=autocompleteBar.js.map